import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { FieldResource } from "../../core/modules/openapi";

@Component({
  selector: "app-checkbox",
  imports: [MatCheckboxModule, MatTooltipModule, ReactiveFormsModule, CommonModule],
  template: `
    <div class="demo-full-width margin-top" [formGroup]="group">
      <mat-checkbox [formControlName]="field.name||null" color="primary"
                    [checked]=field.value>{{ field.displayName }}&nbsp;
        <mat-tooltip-component *ngIf="field.hint" md-direction="top" style="font-size: 12px;">
          - <i class="material-icons"
               style="font-size: 17px;vertical-align: text-bottom;">&#xE88F;</i>
          &nbsp;{{ field.hint }}&nbsp;
        </mat-tooltip-component>
      </mat-checkbox>
    </div>
  `,
  standalone: true,
  styles: []
})
export class CheckboxComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;

  constructor() { }
  ngOnInit() { }
}
